/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

// Custom AddToCart tracking for Meta Pixel
document.addEventListener('DOMContentLoaded', function () {
  // Track traditional form submissions
  document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
    form.addEventListener('submit', function () {
      if (typeof fbq === 'function') {
        fbq('track', 'AddToCart');
      }
    });
  });

  // Track AJAX-based Add to Cart buttons
  document.body.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-add-to-cart], .js-product-add');
    if (btn) {
      if (typeof fbq === 'function') {
        fbq('track', 'AddToCart');
      }
    }
  });
});